import request from "@/utils/request";
import { noop } from "lodash-es";

export function downloadFile(fileId) {
  return request({
    url: `/file/download/${fileId}`,
    method: "POST",
    headers: {
      directResponse: true
    },
    responseType: "arraybuffer"
  });
}

export function deleteFile(fileId) {
  return request({
    url: `/file/delete/${fileId}`,
    method: "DELETE"
  });
}

export function queryFileList(data) {
  return request({
    url: "/file/list",
    method: "POST",
    data
  });
}

/**
 * 通用的文件上传接口,图片和附件等
 */
export function uploadFile(file, { onProgress = noop } = {}) {
  const formData = new FormData();
  formData.append("file", file); // "file" 是后端接收的字段名
  return request({
    url: "/file/upload",
    method: "POST",
    headers: {
      "Content-Type": "multipart/form-data"
    },
    data: formData
  });
}

/**
 * 新云平台的上传接口
 */
export function uploadFileForCloud(file, { onProgress = noop } = {}) {
  const formData = new FormData();
  formData.append("file", file); // "file" 是后端接收的字段名
  return request({
    url: "/cloud/file/manage/uploadEmailImage",
    method: "POST",
    headers: {
      "Content-Type": "multipart/form-data"
    },
    data: formData
  });
}
